





































import { Component, Mixins, Prop } from "vue-property-decorator";

@Component
export default class TexturePattern extends Mixins() {
  @Prop()
  color: string;

  @Prop()
  prefix: string;

  toUniqueId(textureId: number) {
    return this.prefix + textureId;
  }

  get style() {
    return {
      stroke: this.color,
      fill: this.color,
    };
  }
}
